






















import AbpBase from "@/lib/abpbase";
import { Component } from "vue-property-decorator";
import {
  ChangeSettings,
  GetSettings,
  GetFormsEnabled,
} from "@/api/configuration";
import {
  GetDiseaseTypes
} from "@/api/pdReferral";
import settingForm from "./parts/settingForm.vue";
import { GetBIReportList } from "@/api/biReport";
import ajax from "@/lib/ajax";
import util from "@/lib/util";
@Component({
  components: { settingForm },
})
export default class extends AbpBase {
  loading = false;


  created() {
    this.getData();
  }
  BIReportList: any[] = [];
  async getData() {
    this.loading = true;
    this.BIReportList = [];
    this.BIReportList.push({ value: "0", text: "空白模板" });
    let res = await GetSettings();
    let res1 = await GetBIReportList({ queryString: "" });
    let res2 = await GetFormsEnabled();
    let res3 = await GetDiseaseTypes();
    if (res1.objects) {
      res1.objects.forEach((item:any) => {
        this.BIReportList.push({
          value: item.reportName,
          text: item.reportName,
        });
      });
    }
    if (res && res.objects) {
      res.objects.forEach((item:any) => {
        this.basicSettings.forEach((setting:any) => {
          if (item.name == setting.name) {
            setting.value = item.value;
          }
          if (setting.name == "HomeTemplate") {
            setting.options = this.BIReportList;
          }
        });

        this.emrSetting.forEach((setting:any) => {
          if (item.name == setting.name) {
            setting.value = item.value;
            if (item.name == "PatientDetailListShow") {
              if (item.value) {
                setting.valueList = item.value.split(",");
              }
            }
            if (item.name == "PdAssessListShow") {
              if (item.value) {
                setting.valueList = item.value.split(",");
              }
            }
          }

          if (setting.name == "defaultEnableAssess") {
            setting.options = res2.objects;
            if (item.value) {
              setting.valueList = setting.value.split(",");
            }
          }

          if (setting.name == "defaultDiseaseType") {
            setting.options = res3;
          }
        });
        this.emrfollowSettings.forEach((setting) => {
          if (item.name == setting.name) {
            setting.value = item.value;
          }
          if (setting.name == "HomeTemplate") {
            setting.options = this.BIReportList;
          }
        });
      });
    }

    this.loading = false;
  }

  async save() {
    let payload = {
      settings: [
        ...this.basicSettings,
        ...this.emrSetting,
        ...this.emrfollowSettings,
      ],
    };
    let res = await ChangeSettings(payload);
    if (res.status == 1) {
      await this.reloadSettings();
    }
  }

  async reloadSettings() {
    ajax.get("/AbpUserConfiguration/GetAll").then((data) => {
      util.abp = util.extend(true, util.abp, data.data.result);
      console.log("util.abp.setting已刷新");
    });
  }

  basicSettings: any = [
    {
      name: "CompanyName",
      value: "",
      text: "公司名称",
      description: "",
      type: "text",
    },
    {
      name: "SystemName",
      value: "慢病管理系统",
      text: "系统名称",
      description: "",
      type: "text",
    },
    {
      name: "Copyright",
      value: "Copyright©2019 上海声典网络科技有限公司",
      text: "Copyright",
      description: "",
      type: "text",
    },
    {
      name: "Logo",
      value: "",
      text: "Logo图片路径",
      description: "",
      type: "text",
    },
    {
      name: "HospitalName",
      value: "",
      text: "医院名称",
      description: "",
      type: "text",
    },
    {
      name: "HomeTemplate",
      value: "0",
      text: "主页模板",
      description: "",
      type: "select",
      options: [],
    },
    {
      name: "MobileMsgTempForPatient",
      value: "",
      text: "短信模板-患者",
      description: "用于给患者发送短信通知",
      type: "textarea",
    },
    {
      name: "MobileMsgTempForDoctor",
      value: "",
      text: "短信模板-医护",
      description: "用于给医护人员发送短信通知",
      type: "textarea",
    },
    {
        name: "passwordCheck",
        value: "",
        text: "密码校验正则表达式",
        description: "不填写不校验，填写后如密码不满足要求则需修改密码（举例正则：/^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[!#@*&.])[a-zA-Z\d!#@*&.]{8,}$/）",
        type: "text",
    },
    {
        name: "passwordCheckMassage",
        value: "",
        text: "密码校验满足条件",
        description: "提示语句：您的密码不满足‘密码校验满足条件’,请修改密码！",
        type: "text",
    },
  ];

  emrSetting: any = [
    {
      name: "PatientListHISButonShow",
      value: "0",
      text: "患者列表显示HIS病历按钮",
      description: "",
      type: "radio",
      options: [
        {
          value: "0",
          text: "隐藏",
        },
        {
          value: "1",
          text: "显示",
        },
      ],
    },
    {
      name: "followHideRisk",
      value: "0",
      text: "隐藏随访中的疾病行为危险因素信息（相关病史中维护该部分）",
      description: "",
      type: "radio",
      options: [
        {
          value: "0",
          text: "显示",
        },
        {
          value: "1",
          text: "隐藏",
        },
      ],
    },

    {
      name: "PatientListHISNameChange",
      value: "HIS病历",
      text: "患者列表HIS病历名称",
      description: "",
      type: "text",
    },
    {
      name: "PatientListHISType",
      value: "0",
      text: "患者列表HIS病历类别",
      description: "",
      type: "radio",
      options: [
        {
          value: "0",
          text: "网页链接",
        },
        {
          value: "1",
          text: "客户端程序",
        },
      ],
    },
    {
      name: "PatientPrimaryDiagType",
      value: "0",
      text: "患者原发病诊断使用诊断字典模式",
      description:
        "诊断字典模式与原模式表结构不同，修改模式后，不会显示另一个模式数据",
      type: "radio",
      options: [
        {
          value: "0",
          text: "否",
        },
        {
          value: "1",
          text: "是",
        },
      ],
    },
    {
      name: "PatientDetailListShow",
      text: "患者明细列表显示",
      value:
        "基本信息,相关病史,问诊记录,检查,诊断,综合评估,营养,宣教,随访,转归,his药品记录,门诊挂号记录,居家用药",
      description: "",
      type: "selectmultiple",
      options: [
        {
          value: "基本信息",
          text: "基本信息",
        },
        {
          value: "相关病史",
          text: "相关病史",
        },
        {
          value: "问诊记录",
          text: "问诊记录",
        },
        {
          value: "检查",
          text: "检查",
        },
        {
          value: "诊断",
          text: "诊断",
        },
        {
          value: "诊断记录",
          text: "诊断记录",
        },
        {
          value: "综合评估",
          text: "综合评估",
        },
        {
          value: "营养",
          text: "营养",
        },
        {
          value: "宣教",
          text: "宣教",
        },
        {
          value: "随访",
          text: "随访",
        },
        {
          value: "转归",
          text: "转归",
        },
        {
          value: "评估单",
          text: "评估单",
        },
        {
          value: "his药品记录",
          text: "his药品记录",
        },
        {
          value: "门诊挂号记录",
          text: "门诊挂号记录",
        },
        {
          value: "居家用药",
          text: "居家用药",
        },
        {
          value: "病种变更记录",
          text: "病种变更记录",
        },
      ],
    },
    {
      name: "PdAssessListShow",
      text: "患者列表综合评估显示",
      value:
        "tabPdAssessNutrition,tabPDAssessAnxiety",
      description: "",
      type: "selectmultiple",
      options: [
        {
          value: "tabPdAssessNutrition",
          text: "营养评估",
        },
        {
          value: "tabPDAssessAnxiety",
          text: "心理SAS",
        },
        {
          value: "tabPDAssessMotion",
          text: "运动评估",
        },
        {
          value: "tabPDAssessPSQI",
          text: "睡眠障碍评估",
        },
        {
          value: "tabPDAssessNutritionSql",
          text: "营养评估(表单)",
        },
        {
          value: "tabPDAssessPsychology",
          text: "心理健康评估",
        },
        {
          value: "tabPDAssesslife",
          text: "生活质量评估",
        },
        {
          value: "tabPDAssessPain",
          text: "疼痛管理评估",
        },
        {
          value: "tabPDAssessCognition",
          text: "认知障碍评估",
        },
        {
          value: "tabPDAssessMuscle",
          text: "肌少症、衰弱评估",
        },
        {
          value: "tabPDAssessChina",
          text: "中医证候",
        },
      ],
    },
    {
      name: "assayResultQueryDate",
      value: "0",
      text: "实验室检查日期范围默认值",
      type: "select",
      options: [
        {
          value: "0",
          text: "6天",
        },
        {
          value: "1",
          text: "半年",
        },
        {
          value: "2",
          text: "三个月",
        },
      ],
    },
    {
      name: "defaultEnableAssess",
      value: "随访表单,患者接听状态记录,患者延期随访记录",
      text: "评估单默认评估表",
      description: "",
      type: "selectmultiple",
      options: [
            {
                value: "随访表单",
                text: "随访表单",
            },
            {
                value: "患者接听状态记录",
                text: "患者接听状态记录",
            },
            {
                value: "患者延期随访记录",
                text: "患者延期随访记录",
            },
      ],
    },
    {
      name: "IsPathologicDiagnosis",
      value: "0",
      text: "病理信息",
      description: "",
      type: "radio",
      options: [
        {
          value: "0",
          text: "不启用",
        },
        {
          value: "1",
          text: "启用",
        },
      ],
    },
    {
      name: "IsGcpDiagnosis",
      value: "0",
      text: "GCP信息",
      description: "",
      type: "radio",
      options: [
        {
          value: "0",
          text: "不启用",
        },
        {
          value: "1",
          text: "启用",
        },
      ],
    },
    {
      name: "OrderByLastLisTime",
      value: "0",
      text: "患者列表按最后检验时间排序",
      description: "",
      type: "radio",
      options: [
        {
          value: "0",
          text: "不启用",
        },
        {
          value: "1",
          text: "启用",
        },
      ],
    },
    {
      name: "PathologyExamNameDefault",
      value: "病理检查",
      text: "病理检查记录默认查询类别",
      description:
        "此配置项用于控制病理模块查询pacs记录时的ExamName类别，可以配置为多个值，用逗号隔开。",
      type: "text",
    },
    {
      name: "PatQueryOtherItem",
      value: "0",
      text: "患者管理——高级检索增加其他指标检索框",
      description: "",
      type: "radio",
      options: [
        {
          value: "0",
          text: "否",
        },
        {
          value: "1",
          text: "是",
        },
      ],
    },
    {
      name: "PatQueryBirthdayChangeAddress",
      value: "0",
      text: "患者管理——列表中“出生日期”替换为“地址”显示",
      description: "",
      type: "radio",
      options: [
        {
          value: "0",
          text: "否",
        },
        {
          value: "1",
          text: "是",
        },
      ],
    },
    {
      name: "PatQueryNextLevelShow",
      value: "0",
      text: "患者管理——‘显示已分配至下一层级患者’查询条件",
      description: "",
      type: "radio",
      options: [
        {
          value: "0",
          text: "否",
        },
        {
          value: "1",
          text: "是",
        },
      ],
    },
    {
      name: "AssessNutritionHideYTB",
      value: "0",
      text: "患者管理——营养评估隐藏腰围，臀围，腰臀比",
      description: "",
      type: "radio",
      options: [
        {
          value: "0",
          text: "否",
        },
        {
          value: "1",
          text: "是",
        },
      ],
    },
    {
      name: "NoManagedOrderByNo",
      value: "0",
      text: "患者管理——未纳入患者筛查排序",
      description: "",
      type: "radio",
      options: [
        {
          value: "0",
          text: "否",
        },
        {
          value: "1",
          text: "中山排序规则",
        },
      ],
    },
    {
      name: "HomeMedicationUseNew",
      value: "0",
      text: "居家用药药品名称采用药品维护库",
      description: "",
      type: "radio",
      options: [
        {
          value: "0",
          text: "不启用",
        },
        {
          value: "1",
          text: "启用",
        },
      ],
    },
    {
      name: "PdAssessSMotionUseSQL",
      value: "0",
      text: "运动量表用“BROG量表”替换",
      description: "",
      type: "radio",
      options: [
        {
          value: "0",
          text: "不启用",
        },
        {
          value: "1",
          text: "启用",
        },
      ],
    },
    {
      name: "pdAssessNutritionAddMis",
      value: "0",
      text: "综合评估中营养评估添加MIS评估",
      description: "",
      type: "radio",
      options: [
        {
          value: "0",
          text: "不启用",
        },
        {
          value: "1",
          text: "启用",
        },
      ],
    },
    { 
      name: "PdAssessSNutritionName",
      value: "0",
      text: "原营养评估改名为体征评估",
      description: "",
      type: "radio",
      options: [
        {
          value: "0",
          text: "不启用",
        },
        {
          value: "1",
          text: "启用",
        },
      ],
    },
     {
      name: "pdAssessNutritionAddLeftRightGrip",
      value: "0",
      text: "综合评估--营养评估--握力改成左右手握力",
      description: "",
      type: "radio",
      options: [
        {
          value: "0",
          text: "不启用",
        },
        {
          value: "1",
          text: "启用",
        },
      ],
    },
    {
      name: "pdAssessNutritionReplacelabor",
      value: "0",
      text: "综合评估--营养评估--职业与劳动强度替换为小臂围和腹围",
      description: "",
      type: "radio",
      options: [
        {
          value: "0",
          text: "不启用",
        },
        {
          value: "1",
          text: "启用",
        },
      ],
    },
    {
      name: "pdPatientAddPatientLevel",
      value: "0",
      text: "患者管理——列表中增加分级显示",
      description: "",
      type: "radio",
      options: [
        {
          value: "0",
          text: "不启用",
        },
        {
          value: "1",
          text: "启用",
        },
      ],
    },
    {
      name: "Needtomanagebackgroundcolor",
      value: "FF7F50",
      text: "待管理--已纳入需管理的患者背景颜色",
      description: "有背景色的字体统一白色，用6位不带#的颜色代码(‌十六进制HEX)",
      type: "text",
    },
    {
      name: "todatemanagebackgroundcolor",
      value: "DB7093",
      text: "需管理--下次随访时间等于昨天天的患者背景颜色",
      description: "有背景色的字体统一白色，用6位不带#的颜色代码(‌十六进制HEX)",
      type: "text",
    },
    {
      name: "nowdatemanagebackgroundcolor",
      value: "7FFF00",
      text: "需管理--下次随访时间等于今天的患者背景颜色",
      description: "有背景色的字体统一白色，用6位不带#的颜色代码(‌十六进制HEX)",
      type: "text",
    },
    {
      name: "defaultDiseaseType",
      value: "",
      text: "患者管理默认病种",
      description: "",
      type: "select",
      options: [],
    },
  ];

  emrfollowSettings: any = [
    {
      name: "followUpUserSql",
      value: "",
      text: "随访使用SQL维护模式显示",
      description:
        "选是sql维护导入'随访表单-患者列表'字段名称固定最近/下次随访时间根据填写表单自行修改sql。随访表单需要3大模块添加'随访表单'",
      type: "radio",
      options: [
        {
          value: "0",
          text: "否",
        },
        {
          value: "1",
          text: "是",
        },
      ],
    },
    {
      name: "followUpUserSqlDocter",
      value: "",
      text: "随访使用SQL维护模式显示区分医生与护士",
      description:  "开启后，需配置医生随访表单，登录医生账号点击随访为打开医生随访表单",
      type: "radio",
      options: [
        {
          value: "0",
          text: "否",
        },
        {
          value: "1",
          text: "是",
        },
      ],
    },
    {
      name: "followUpUserSqlFormId",
      value: "fdb585bc-c51b-4d63-b9ef-b4e862649587",
      text: "随访表单的FormId（需先填写该项）",
      description: "此配置项用于配置sql维护配置的随访表单的FormId",
      type: "text",
    },
    {
      name: "followUpUserSqlFollowTime",
      value: "grid_SuiFangXinXi01.SuiFangRiQi",
      text: "随访表单的随访时间",
      description: "此配置项用于配置sql维护配置的随访表单中随访时间的json路径",
      type: "text",
    },
    {
      name: "followUpUserSqlFollowStatus",
      value: "grid_SuiFangXinXi01.SuiFangZhuangTai",
      text: "随访表单的随访状态",
      description: "此配置项用于配置sql维护配置的随访表单中随访状态的json路径",
      type: "text",
    },
    {
      name: "followUpUserSqlNextFollowTime",
      value: "grid_SuiFangXinXi03.YuYueXiaCiSuiFangRiQi",
      text: "随访表单的下次随访时间",
      description:
        "此配置项用于配置sql维护配置的随访表单中下次随访时间的json路径",
      type: "text",
    },
    {
      name: "AssessResultBindvalueAfterDay",
      value: "0",
      text: "修改质控评估单固定期限（天）",
      description: "按照质控时间来计算，超过该期限后，只有能修改数据权限的账号可修改，不填写时间不启用（填写整数）",
      type: "text",
    },
    {
      name: "AssessFormNextFollowTimeTo",
      value: "0",
      text: "随访评估单预约下次随访自动添加到预排版界面",
      description: "按照质控时间来计算，超过该期限后，只有能修改数据权限的账号可修改，不填写时间不启用（填写整数）",
      type: "radio",
      options: [
        {
          value: "0",
          text: "否",
        },
        {
          value: "1",
          text: "是",
        },
      ],
    },
    
  ];
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/setting/configuration/index.vue